var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47 132 L 114 132 L 114 337.5 L 47 337.5 Z M 47 132 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 43.3125 37.5 L 119 37.5 L 119 113 L 43.3125 113 Z M 43.3125 37.5 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142 125 L 332.0625 125 L 332.0625 337.5 L 142 337.5 Z M 142 125 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509277%,17.248535%,24.308777%)",
      fillOpacity: 1
    },
    d: "M 61.980469 375 L 313.019531 375 C 347.195312 375 375 347.195312 375 313.019531 L 375 61.980469 C 375 27.804688 347.195312 0 313.019531 0 L 61.980469 0 C 27.804688 0 0 27.804688 0 61.980469 L 0 313.019531 C 0 347.195312 27.804688 375 61.980469 375 Z M 61.980469 375 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 47.941406 337.5 L 113.988281 337.5 L 113.988281 132.0625 L 47.941406 132.0625 Z M 47.941406 337.5 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 80.964844 37.5 C 60.230469 37.5 43.359375 54.347656 43.359375 75.058594 C 43.359375 95.765625 60.230469 112.617188 80.964844 112.617188 C 101.703125 112.617188 118.574219 95.765625 118.574219 75.058594 C 118.574219 54.347656 101.703125 37.5 80.964844 37.5 Z M 80.964844 37.5 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 331.996094 194.085938 C 331.125 155.796875 299.742188 125.808594 260.546875 125.808594 C 238.851562 125.808594 218.703125 135.410156 205.1875 151.847656 L 205.1875 132.0625 L 142.390625 132.0625 L 142.390625 337.5 L 208.4375 337.5 L 208.4375 218.75 C 208.4375 202.929688 221.328125 190.058594 237.167969 190.058594 C 253.011719 190.058594 265.902344 202.925781 265.902344 218.75 L 265.972656 337.5 L 332.015625 337.5 Z M 331.996094 194.085938 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.782f43665c8090d80364599d87d1bbd0.svg";
export { ForwardRef as ReactComponent };